export function RecordVoiceAudios(
    recordingDone,
    updateRecordingStatus,
    setRecordingFinished
) {
    let encoder = null;
    let microphone;
    // let isRecording = false;
    let stopBtnRecord;
    let audioContext;
    let processor;
    let config = {
        bufferLen: 4096,
        numChannels: 2,
        mimeType: 'audio/mpeg',
    };

    this.stopRecord = function () {
        stopBtnRecord();
    };

    const logError = (error) => {
        alert(error);
        console.log(error);
    };

    const getBuffers = (event) => {
        const buffers = [];
        for (let ch = 0; ch < 2; ++ch)
            buffers[ch] = event.inputBuffer.getChannelData(ch);
        return buffers;
    };

    this.startRecord = function () {
        console.log('Starting record');

        const gotStreamMethod = (stream) => {
            config = {
                bufferLen: 4096,
                numChannels: 2,
                mimeType: 'audio/mpeg',
            };
            // isRecording = true;

            const tracks = stream.getTracks();
            /**
             * Create a MediaStreamAudioSourceNode for the microphone
             * */
            microphone = audioContext.createMediaStreamSource(stream);
            /**
             * connect the AudioBufferSourceNode to the gainNode
             * */
            microphone.connect(processor);
            encoder = new Mp3LameEncoder(audioContext.sampleRate, 160);
            /**
             * Give the node a function to process audio events
             */
            processor.onaudioprocess = function (event) {
                encoder.encode(getBuffers(event));
            };

            stopBtnRecord = () => {
                console.log('stopBtnRecord');
                updateRecordingStatus(false);
                setRecordingFinished(true);
                // isRecording = false;
                audioContext.close();
                processor.disconnect();
                tracks.forEach((track) => track.stop());

                const file = new File([encoder.finish()], 'recording.mp3');
                recordingDone(file);
            };
        };

        audioContext = new AudioContext();
        /**
         * Create a ScriptProcessorNode with a bufferSize of
         * 4096 and two input and output channel
         * */
        if (audioContext.createJavaScriptNode) {
            processor = audioContext.createJavaScriptNode(
                config.bufferLen,
                config.numChannels,
                config.numChannels
            );
        } else if (audioContext.createScriptProcessor) {
            processor = audioContext.createScriptProcessor(
                config.bufferLen,
                config.numChannels,
                config.numChannels
            );
        } else {
            console.log('WebAudio API has no support on this browser.');
        }

        processor.connect(audioContext.destination);
        /**
         *  ask permission of the user for use microphone or camera
         * */
        navigator.mediaDevices
            .getUserMedia({ audio: true, video: false })
            .then(updateRecordingStatus(true))
            .then(gotStreamMethod)
            .catch(logError);
    };
}
